import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SnackbarService } from '@shared';
import {
  AdditionalDataActionTypes,
  getAdditionalDataFailure,
  getAdditionalDataSuccess,
  updateAdditionalDataFailure,
  updateAdditionalDataSuccess,
} from '../actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { AdditionalDataService } from '../../services';
import { IAdditionalData } from '@shared/model/basic-data';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from '@app/errors/errors.service';

@Injectable()
export class AdditionalDataEffects {
  constructor(
    private _actions$: Actions,
    private _additionalDataService: AdditionalDataService,
    private _snackbarService: SnackbarService,
    private _errorsService: ErrorsService,
  ) {}

  getAdditionalData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AdditionalDataActionTypes.GET_ADDITIONAL_DATA),
      mergeMap(({ id }) =>
        this._additionalDataService.getAdditionalData(id).pipe(
          map((additionalData: IAdditionalData) => getAdditionalDataSuccess({ additionalData })),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getAdditionalDataFailure());
          }),
        ),
      ),
    ),
  );

  updateAdditionalData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AdditionalDataActionTypes.UPDATE_ADDITIONAL_DATA),
      mergeMap(({ id, data }) =>
        this._additionalDataService.updateAdditionalData(id, data).pipe(
          map(() => updateAdditionalDataSuccess({ data })),
          catchError(() => of(updateAdditionalDataFailure())),
        ),
      ),
    ),
  );
}
